import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, isStaff } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";
import { apiErr } from "@/lib/api";
import AuthShell from "./AuthShell";
import { Field, Input } from "@/components/Field";
import GoogleButton from "@/components/GoogleButton";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "";
  const [f, setF] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const dest = (u) => (isStaff(u) ? "/admin" : (next || "/portal"));

  useEffect(() => {
    const gerr = params.get("google_error");
    if (gerr) {
      toast.error(t(`auth.googleErr.${gerr}`) || t("auth.googleErr.failed"));
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []); // eslint-disable-line

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(f.email, f.password);
      toast.success("Willkommen!");
      nav(dest(u));
    } catch (err) { toast.error(apiErr(err)); }
    setLoading(false);
  };

  return (
    <AuthShell title={t("auth.loginTitle")} subtitle={t("nav.portal")}>
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <Field label={t("common.email")}><Input testid="login-email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} /></Field>
        <Field label={t("auth.password")}><Input testid="login-password" type="password" required value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} /></Field>
        <div className="text-right"><Link to="/forgot-password" className="text-sm text-primary" data-testid="login-forgot">{t("auth.forgot")}</Link></div>
        <button className="btn-primary w-full" disabled={loading} data-testid="login-submit">{loading ? "…" : t("nav.login")}</button>
      </form>
      <GoogleButton next={next} />
      <p className="text-sm text-muted-foreground mt-6 text-center">{t("auth.noAccount")} <Link to={`/register${next ? `?next=${encodeURIComponent(next)}` : ""}`} className="text-primary font-semibold" data-testid="login-register-link">{t("nav.register")}</Link></p>
    </AuthShell>
  );
}
